export const dateFormatter = params => {
  var arr = params.value.split("-");
  return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
};
